import React, { useState, useRef } from "react";
import axios from "axios";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Box, IconButton, Button, FormControl, CircularProgress } from "@mui/material";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "@egovernments/digit-ui-react-components";
import { getDocumentByFileStoreId, getDocumentByFileStoreIdV2 } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { Controller, useForm } from "react-hook-form";
export default function FileUploader({
  name,
  label,
  hasLabel = true,
  isMandatory = false,
  validationMsg,
  required,
  tab,
  showError,
  setShowError,
  setFile,
  maxFiles = 5,
  templateMessage = false,
  isMigrated = false,
}) {
  console.log("inside Land use uploader", showError, name);
  const { control } = useForm();
  const fileInputRef = useRef();
  const { documents } = useSelector((state) => state.formMT);
  console.log("documentsFromUploader", documents);

  const dispatch = useDispatch();
  const { addFormMTDoc, removeFormMTDoc } = bindActionCreators(formMTDocActions, dispatch);

  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [isLoading, setIsLoading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const uploadedFiles = documents?.filter((doc) => doc.documentType === name) || [];
  const isAccepted = uploadedFiles?.[0]?.documentStatus === "Accepted"
  const handleFileUpload = async (e, inputName) => {
    const file = e.target.files[0];
    console.log("insideFileUpload");

    setIsLoading(true);
    setShowToast(null);
    const invalidMalwareExtensions = [
      "php",
      "php3",
      "php4",
      "php5",
      "phtml",
      "asp",
      "aspx",
      "jsp",
      "jspx",
      "cfm",
      "exe",
      "bat",
      "cmd",
      "sh",
      "com",
      "scr",
      "msi",
      "jar",
      "vbs",
      "ps1",
      "dll",
      "docm",
      "xlsm",
      "pptm",
      "dotm",
      "xltm",
      "html",
      "htm",
      "js",
      "xml",
      "svg",
      "zip",
      "rar",
      "7z",
      "tar",
      "gz",
      "iso",
    ];
    const fileParts = file.name.toLowerCase().split(".");
    const finalExt = fileParts[fileParts.length - 1];
    const intermediateParts = fileParts.slice(0, -1);
    const hasMaliciousExtension = intermediateParts.some((part) => invalidMalwareExtensions.includes(part));
    if (!file) {
      setShowToast({ error: true, label: "Please select a file." });
      setIsLoading(false);
      return;
    }
    if (hasMaliciousExtension) {
      setShowToast({
        error: true,
        label: "Invalid file name: contains potentially dangerous extensions.",
      });
      setIsLoading(false);
      return;
    }

    // Check if the number of uploaded files is greater than or equal to maxFiles
    if (documents?.filter((doc) => doc.documentType === name).length >= maxFiles) {
      setShowToast({ error: true, label: `You can upload a maximum of ${maxFiles} files.` });
      setIsLoading(false);
      return;
    }

    // Validation based on tab value
    if (tab === 1) {
      const allowedFormats = [".pdf", ".PDF"];
      const fileExtension = file.name.split(".").pop();
      if (!allowedFormats.includes(`.${fileExtension}`)) {
        setShowToast({ error: true, label: "Please select a file with a valid format (.pdf, .PDF)." });
        setIsLoading(false);
        return;
      }
      const maxSizeInBytes = 10 * 1024 * 1024; // 10 MB
      if (file.size > maxSizeInBytes) {
        setShowToast({ error: true, label: "File size exceeds the maximum limit of 10 MB." });
        setIsLoading(false);
        return;
      }
    } else if (tab === 2) {
      const allowedFormats = [".png", ".jpg", ".jpeg", ".JPG", ".PNG", ".JPEG"];
      const fileExtension = file.name.split(".").pop();
      if (!allowedFormats.includes(`.${fileExtension}`)) {
        setShowToast({ error: true, label: "Please select a file with a valid format (.png, .jpg, .jpeg)." });
        setIsLoading(false);
        return;
      }
      const maxSizeInBytes = 10 * 1024 * 1024; // 10 MB
      if (file.size > maxSizeInBytes) {
        setShowToast({ error: true, label: "File size exceeds the maximum limit of 10 MB." });
        setIsLoading(false);
        return;
      }
    } else if (tab === 3) {
      const allowedFormats = [".dxf", ".DXF"];
      const fileExtension = file.name.split(".").pop();
      if (!allowedFormats.includes(`.${fileExtension}`)) {
        setShowToast({ error: true, label: "Please select a file with a valid format (.dxf)." });
        setIsLoading(false);
        return;
      }
      const maxSizeInBytes = 300 * 1024 * 1024; // 300 MB for EDCR
      if (file.size > maxSizeInBytes) {
        setShowToast({ error: true, label: "File size exceeds the maximum limit of 300 MB." });
        setIsLoading(false);
        return;
      }
      setFile(file);
    } else if (tab === 5) {
      const allowedFormats = [".dxf", ".DXF"];
      const fileExtension = file.name.split(".").pop();
      if (!allowedFormats.includes(`.${fileExtension}`)) {
        setShowToast({ error: true, label: "Please select a file with a valid format (.dxf)." });
        setIsLoading(false);
        return;
      }
      const maxSizeInBytes = 300 * 1024 * 1024; // 300 MB for EDCR
      if (file.size > maxSizeInBytes) {
        setShowToast({ error: true, label: "File size exceeds the maximum limit of 300 MB." });
        setIsLoading(false);
        return;
      }
    } else if (tab === 6) {
      const allowedFormats = [".xls", ".XLS", ".xlsx", ".XLSX"];
      const fileExtension = file.name.split(".").pop();
      if (!allowedFormats.includes(`.${fileExtension}`)) {
        setShowToast({ error: true, label: "Please select a file with a valid format (.xls, .xlsx)." });
        setIsLoading(false);
        return;
      }
      const maxSizeInBytes = 300 * 1024 * 1024; // 300 MB for EDCR
      if (file.size > maxSizeInBytes) {
        setShowToast({ error: true, label: "File size exceeds the maximum limit of 300 MB." });
        setIsLoading(false);
        return;
      }
    } else {
      const allowedFormats = [".pdf", ".PDF"];
      const fileExtension = file.name.split(".").pop();
      if (!allowedFormats.includes(`.${fileExtension}`)) {
        setShowToast({ error: true, label: "Please select a file in a pdf format" });
        setIsLoading(false);
        return;
      }
      const maxSizeInBytes = 300 * 1024 * 1024; // 30 MB for PDF
      if (file.size > maxSizeInBytes) {
        setShowToast({ error: true, label: "File size exceeds the maximum limit of 300 MB." });
        setIsLoading(false);
        return;
      }
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("tenantId", "up");
    formData.append("module", "property-upload");
    formData.append("tag", "tag-property");

    try {
      if (documents?.filter((doc) => doc.documentType === inputName).length >= maxFiles) {
        removeFormMTDoc(inputName);
      }
      const resp = await axios.post("/filestore/v1/files", formData, {});
      const filesId = resp.data.files[0];
      addFormMTDoc({
        documentType: inputName,
        fileStoreId: filesId.fileStoreId,
        isMandatory,
        additionalDetails: { fileName: file.name, title: label },
      });
      e.target.value = null;
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <div className="inputContainer" style={{ alignItems: "flex-start" }}>
        {hasLabel && (
          <h3 className={`label`} style={{ width: "100%" }}>
            {label}
            {templateMessage && <span className="template-Text">{"AS PER TEMPLATE"}</span>}
            {isMandatory && <span className="compulsoryField"> *</span>}
          </h3>
        )}

        <Box sx={{ flexDirection: "column", position: "relative", width: "100%", display: "flex" }}>
          {/* Custom File Input UI */}
          <FormControl fullWidth sx={{ display: "flex", alignItems: "center" }}>
            <Button
              variant="outlined"
              component="span"
              onClick={() => fileInputRef.current.click()} // Trigger file input click
              sx={{
                width: "100%",
                mb: 1,
                display: "flex",
                justifyContent: "space-between",
                height: "30px",
                backgroundColor: "rgb(21, 124, 179)",
                color: "white",
                "&:hover": {
                  backgroundColor: "#004e6c", // Darker shade of blue
                  color: "#fff", // Keep text white
                },
              }}
            >
              {isLoading ? (
                <Box sx={{ justifyContent: "center", position: "absolute", alignItems: "center", display: "flex", inset: 0 }}>
                  <CircularProgress sx={{ color: "#ffffff" }} size={28} />
                </Box>
              ) : (
                <React.Fragment>
                  <CloudUploadOutlinedIcon />
                  <span style={{ position: "absolute", fontSize: "0.5rem", marginLeft: "8em" }}>{validationMsg}</span>
                </React.Fragment>
              )}
            </Button>

            <Controller
              name="fileInput"
              control={control}
              rules={{
                required: required && !documents?.some((doc) => doc.documentType === name),
              }}
              render={({ field }) => (
                <input
                  {...field}
                  ref={fileInputRef}
                  type="file"
                  name={name}
                  style={{ display: "none" }} // Hide the native file input
                  onChange={(e) => handleFileUpload(e, name)} // Handle file selection
                />
              )}
            />
          </FormControl>
        </Box>
      </div>

      {/* Display already uploaded documents */}
      {(!isLoading && documents?.length > 0 && (
        <Box sx={{ maxWidth: "100%", display: "flex", flexDirection: "column" }}>
          {documents?.map((doc) => {
            if (doc.documentType !== name) return null;
            return (
              <Box
                sx={{
                  justifyContent: "space-between",
                  p: "0.25rem 0 0.25rem 0.75rem",
                  backgroundColor: "#eee",
                  borderRadius: "0.25rem",
                  wordBreak: "break-all",
                  alignItems: "center",
                  display: "flex",
                  lineHeight: 1,
                  flex: 1,
                  mb: 0.5,
                  mt: 1,
                  height: "18px",
                  fontSize: "0.6rem",
                }}
                key={doc.fileStoreId}
                className="file-wrapper-name"
              >
                {doc.additionalDetails?.fileName || doc.documentType}
                <Box sx={{ display: "flex" }}>
                  <IconButton
                    size="small"
                    color="info"
                    sx={{ fontSize: "1rem" }}
                    onClick={() => isMigrated ? getDocumentByFileStoreIdV2(doc.fileStoreId, setIsPreviewLoading) : getDocumentByFileStoreId(doc.fileStoreId, setIsPreviewLoading)}
                  >
                    {isPreviewLoading ? <CircularProgress /> : <VisibilityIcon />}
                  </IconButton>
                  <IconButton size="small" color="error" sx={{ fontSize: "1rem" }} onClick={() => removeFormMTDoc(doc.documentType)}>
                    <DeleteForeverIcon />
                  </IconButton>
                </Box>
              </Box>
            );
          })}
        </Box>
      )) ||
        null}

      {/* Error message when the file is required and not uploaded */}
      {required && showError && !documents?.some((doc) => doc.documentType === name) && (
        <span className="errorText">{`${hasLabel ? label : "Above"} document is required.`}</span>
      )}
      {!!showToast?.error && <span className="errorText">{showToast.label}</span>}
    </Box>
  );
}
